import SignUpSide from '../components/Auth/SignUpSide';

const RegisterPage = () => {
  return <SignUpSide />;
};

export default RegisterPage;
